import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {UserInterface} from '@core/model/user/user.interface';
import {selectAuthUser} from '@app/redux/auth-user';
import {Store} from '@ngrx/store';
import {AppState} from '@app/redux';
import {loggedUser} from '@app/redux/auth-user/auth-user-actions';
import {navigateTo} from '@app/redux/app.actions';
import {filter, map} from 'rxjs/operators';
import {NbMenuItem, NbMenuService, NbSidebarService, NbTrigger} from '@nebular/theme';
import {logout} from '@feature-module/login/redux/action/login.actions';
import {selectSideMenu, selectTopMenu} from '@app/redux/side-menu';
import {WelfyMenuItem} from '@core/class/menu/welfy-menu-item';

@Component({
  selector: 'app-welfy-container',
  templateUrl: './welfy-container.component.html',
  styleUrls: ['./welfy-container.component.css']
})
export class WelfyContainerComponent implements OnInit {

  sideItems$: Observable<NbMenuItem[]> = this.store.select(selectSideMenu)
    .pipe(
      map(item => item.map(value => this.mapToNbMenuItem(value))
      )
    )
  loggedUser$: Observable<UserInterface> = this.store.select(selectAuthUser);
  items$: Observable<NbMenuItem[]> = this.store.select(selectTopMenu).pipe(
    map(items => items.map(value => this.mapToNbMenuItem(value)))
  )
  readonly trigger = NbTrigger.HOVER;

  constructor(
    private store: Store<AppState>,
    private nbMenuService: NbMenuService,
    private sidebarService: NbSidebarService,
  ) {
  }

  ngOnInit(): void {
    this.store.dispatch(loggedUser());

    // register context menu listener
    this.nbMenuService
      .onItemClick()
      .pipe(
        filter(({tag}) => tag === 'user-menu'),
        map(({item: {title}}) => title)
      )
      .subscribe((title) => {
        this.handleUserMenu(title);
      });

  }

  openUserProfile() {
    this.store.dispatch(navigateTo({path: '/user-profile'}));
  }

  logout() {
    this.store.dispatch(logout());
  }

  toggle() {
    this.sidebarService.toggle(true, 'left');
  }

  private handleUserMenu(title: string) {
    if (title === 'Logout') {
      // logout user
      this.logout();
    } else if (title === 'Profilo') {
      this.openUserProfile();
    }
  }

  private mapToNbMenuItem(welfyMenuItem: WelfyMenuItem): NbMenuItem {
    return {
      title: welfyMenuItem.title,
      children: welfyMenuItem.children ? welfyMenuItem.children.map(i => this.mapToNbMenuItem(i)) : null,
      expanded: welfyMenuItem.expanded,
      hidden: welfyMenuItem.hidden,
      link: welfyMenuItem.link,
      url: welfyMenuItem.url,
      icon: welfyMenuItem.icon
    }
  }

}
